import React from 'react'
import { AdminPropertyAd } from 'types'
import { SvgIcon, Link } from '@mui/material'
import { ReactComponent as SpourgitiSvg } from 'assets/svg/icons/lists/g-spourgiti.svg'

interface Props {
  propertyAd: AdminPropertyAd
  matchesTablet: boolean
}
function ListingLink(props: Props) {
  const { propertyAd } = props
  return (
    <span onClick={(event) => event.stopPropagation()}>
      <Link
        href={
          process.env.REACT_APP_API_BASE_URL +
          `property-ads/el:${propertyAd?.alternativeId}` +
          `/#/property-ads/el:${propertyAd?.alternativeId}`
        }
        underline="none"
        target="_blank"
      >
        <SvgIcon
          component={SpourgitiSvg}
          inheritViewBox
          sx={{
            color: 'black',
            height: { xs: '37px', sm: 'auto' },
            width: { xs: 'auto', sm: '28px' },
          }}
        />
      </Link>
    </span>
  )
}

export default ListingLink
